<form class="">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Delete Saved Route</h4>
    </div>
    <div class="modal-body">
      <div class="card">
        <div class="card-body p-0">
          <div class="d-flex justify-content-start">
            <P
              >Are you sure you want to delete &#32;&#32;
              <span class="font-weight-bold">{{ route.Name }}</span
              >?</P
            >
          </div>
          <div
            class="d-flex flex-column justify-content-center"
            *ngIf="loading"
          >
            <app-spinner></app-spinner>
          </div>
          <div
            class="alert alert-danger fade show"
            role="alert"
            *ngIf="errorMessage !== ''"
          >
            <i class="material-icons alert-icon">error</i>
            <div>{{ errorMessage }}</div>
            <button type="button" class="close" data-dismiss="alert">
              <i class="modus-icon material-icons">close</i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button (click)="cancel()" class="btn btn-outline-dark">Cancel</button>

      <button type="submit" class="btn btn-danger" (click)="deleteRoute()">
        Delete
      </button>
    </div>
  </div>
</form>
